module.exports = require("./chr-US");